import React, { useEffect, useState, useRef } from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import user from "../../assets/images/user.svg";
import phoneIcon from "../../assets/images/phone.svg";
import emailIcon from "../../assets/images/email.svg";
import key from "../../assets/images/key.svg";
import SubHeader from "../staffSignUp/components/subHeader";
// import img from "../../assets/images/1-3.png";
import img from "../../assets/images/1-4.svg";
import role1 from "../../assets/images/role.svg";
import ErrorState from "../staffSignUp/components/errorState";
import { callApi } from "../../../redux/action/action";
import Loader from "../../modals/Loader";
import "react-toastify/dist/ReactToastify.css";
import "./hospSignUp.css";
import uncheck from "../../assets/images/uncheckBox.svg";
import checkBox from "../../assets/images/chekedbox.svg";
import { HeaderComp } from "../staffSignUp/headerComp";
import Doctor from "../../assets/images/signupImageWeb.png";
import DoctorMobile from "../../assets/images/doctorMobile.png";
import logoText from "../../assets/images/logoText.svg";
import logo from "../../assets/images/brandIcon.svg";
import PhoneInput from "react-phone-input-2";
import back from "../../assets/images/back.svg";
import { Link } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import HospSignUp_3 from "./hospSignUp_3";
import { showSuccessToast } from "../../common/toastMeassage/ToastMeassage";
const HospSignUp = ({ history }) => {
  const [showAgreement, setShowAgreement] = useState(false);
  const debounceRef = useRef(null);
  const [state, setState] = useState({
    fullName: "",
    email: "",
    phone: "",
    role: "",
    psw: "",
    repsw: "",
    institutionName: "",
    institutionSize: "",
    institutionWebsite: "",
    zipCode: "",
    streetAddress: "",
    state: "",
    city: "",
    isTermsAccepted: true,
    isMedicalAgreementAccepted: true,
    showLoader: false,
    error: {
      fullName: "none",
      email: "none",
      phone: "none",
      role: "none",
      psw: "none",
      repsw: "none",
      institutionName: "none",
      institutionSize: "none",
      institutionWebsite: "none",
      zipCode: "none",
      streetAddress: "none",
      state: "none",
      city: "none",
      isEmailChecking: false,
    },
  });
  const isFormValid = () => {
    const {
      fullName,
      email,
      phone,
      role,
      psw,
      repsw,
      zipCode,
      streetAddress,
      state: stateName,
      city,
      institutionName,
      institutionSize,
      institutionWebsite,
      isTermsAccepted,
      isMedicalAgreementAccepted,
      error,
      isEmailChecking, // added
    } = state;

    const phoneDigitsOnly = phone.replace(/\D/g, "");
    const isPhoneValid = phoneDigitsOnly.length === 11;
    const isEmailValid = error.email === "none";

    return (
      fullName &&
      email &&
      isEmailValid &&
      !isEmailChecking && // ✅ prevent submission while checking
      isPhoneValid &&
      role &&
      psw &&
      repsw &&
      zipCode &&
      streetAddress &&
      stateName &&
      city &&
      institutionName &&
      institutionSize &&
      institutionWebsite &&
      isTermsAccepted &&
      isMedicalAgreementAccepted
    );
  };

  console.log("isFormValid:", isFormValid());

  const finishSignUp = async () => {
    if (
      !isFormValid() ||
      !state.isTermsAccepted ||
      !state.isMedicalAgreementAccepted
    )
      return;

    setState((prevState) => ({ ...prevState, showLoader: true }));

    const data = {
      name: state.fullName,
      email: state.email,
      hiringRole: state.role,
      healthCareInstitution: {
        name: state.institutionName,
        size: state.institutionSize,
        website: state.institutionWebsite,
      },
      corporateAddress: {
        zipCode: state.zipCode,
        street: state.streetAddress,
        city: state.city,
        state: state.state,
      },
      password: state.psw,
      phone: state.phone,
      avatar: "",
      badge: true,
      ein: state.ein,
    };

    const res = await callApi("POST", "v1/LHS/hospital/signup", null, data);

    setTimeout(() => {
      setState((prevState) => ({ ...prevState, showLoader: false }));
    }, 1000);

    if (res && res.data && res.data._id) {
      localStorage.clear();
      showSuccessToast("Hospital created successfully");
      history.push("/login");
    } else {
      console.error("Error in API response:", res);
    }
  };

  const handleTermsCheckboxToggle = () => {
    setState((prev) => ({
      ...prev,
      isTermsAccepted: !prev.isTermsAccepted,
    }));
  };

  const handleMedicalAgreementCheckboxToggle = () => {
    setState((prev) => ({
      ...prev,
      isMedicalAgreementAccepted: !prev.isMedicalAgreementAccepted,
    }));
  };
  // useEffect(() => {
  //   setState((prev) => ({
  //     ...prev,
  //     fullName: localStorage.getItem("fullName") || "",
  //     email: localStorage.getItem("email") || "",
  //     phone: localStorage.getItem("phone") || "",
  //     role: localStorage.getItem("role") || "",
  //     psw: localStorage.getItem("psw") || "",
  //     repsw: localStorage.getItem("repsw") || "",
  //     institutionName: localStorage.getItem("institutionName") || "",
  //     institutionSize: localStorage.getItem("institutionSize") || "",
  //     institutionWebsite: localStorage.getItem("institutionWebsite") || "",
  //     zipCode: localStorage.getItem("zipCode") || "",
  //     streetAddress: localStorage.getItem("streetAddress") || "",
  //     state: localStorage.getItem("state") || "",
  //     city: localStorage.getItem("city") || "",
  //   }));
  // }, []);

  const togglePasswordVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      isPasswordVisible: !prevState.isPasswordVisible,
    }));
  };

  const toggleConfirmPasswordVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      isConfirmPasswordVisible: !prevState.isConfirmPasswordVisible,
    }));
  };

  const setVal = (e) => {
    const inputValue = e.target.value;
    const name = e.target.name;

    // Special handling for numeric fields
    if (name === "institutionSize") {
      // Only allow numbers (remove all non-digit characters)
      const numericValue = inputValue.replace(/\D/g, "");
      localStorage.setItem(name, numericValue);
      setState((prevState) => ({
        ...prevState,
        [name]: numericValue,
        error: { ...prevState.error, [name]: "none" },
      }));
      return;
    }

    const isAlphaField = ["fname", "lname"].includes(name);
    const isValid = isAlphaField ? /^[A-Za-z\s]+$/.test(inputValue) : true;

    if (isValid || inputValue === "") {
      localStorage.setItem(name, inputValue);
      setState((prevState) => ({
        ...prevState,
        [name]: inputValue,
        error: { ...prevState.error, [name]: "none" },
      }));
    }
    if (name === "zipCode") {
      if (inputValue.length === 5) {
        fetchCityState(inputValue);
      } else {
        setState((prevState) => ({
          ...prevState,
          city: "",
          state: "",
          error: {
            ...prevState.error,
            zipCode: "block",
          },
        }));
      }
    }
    if (name === "institutionWebsite") {
      const urlRegex = /^(https?:\/\/)?([\w\d\-]+\.)+\w{2,}(\/.*)?$/;
      const isValidURL = urlRegex.test(inputValue.trim());

      setState((prevState) => ({
        ...prevState,
        [name]: inputValue,
        error: {
          ...prevState.error,
          institutionWebsite: isValidURL ? "none" : "block",
        },
      }));
      return;
    }
  };

  const fetchCityState = async (zip) => {
    try {
      const result = await callApi("POST", "v1/LHS/other/getCityState", null, {
        zip: zip,
      });

      if (result && result.data && result.data.city && result.data.state) {
        const { city, state: stateName } = result.data;

        setState((prevState) => ({
          ...prevState,
          city,
          state: stateName,
          error: {
            ...prevState.error,
            city: "none",
            state: "none",
            zipCode: "none", // ✅ Clear zip error if valid
          },
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          city: "",
          state: "",
          error: {
            ...prevState.error,
            zipCode: "block", // ❌ Show error
          },
        }));
      }
    } catch (error) {
      console.error("Error fetching city and state:", error);
      setState((prevState) => ({
        ...prevState,
        city: "",
        state: "",
        error: {
          ...prevState.error,
          zipCode: "block", // ❌ Show error
        },
      }));
    }
  };

  const setRole = (e) => {
    if (e.target.value.length < 100) {
      setState((prevState) => ({
        ...prevState,
        role: e.target.value,
        error: { ...prevState.error, role: "none" },
      }));
    }
  };

  const setEmail = (e) => {
    const inputValue = e.target.value.trim();

    // Update value + set checking flag
    setState((prevState) => ({
      ...prevState,
      email: inputValue,
      emailErr: "Valid email address is required.",
      isEmailChecking: true,
    }));

    // Clear previous debounce
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(async () => {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValidEmail = re.test(inputValue.toLowerCase());

      if (inputValue && isValidEmail) {
        const isEmailValid = await emailRepeatCheck(inputValue);

        setState((prevState) => ({
          ...prevState,
          error: {
            ...prevState.error,
            email: isEmailValid ? "none" : "block",
          },
          emailErr: isEmailValid
            ? "Valid email address is required."
            : "This Email address is already in use.",
          isEmailChecking: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          error: {
            ...prevState.error,
            email: "block",
          },
          emailErr: "Valid email address is required.",
          isEmailChecking: false,
        }));
      }
    }, 0); // Recommended: increase to at least 300ms
  };

  const setPhone = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    const isValid = digitsOnly.length === 11;

    setState((prevState) => ({
      ...prevState,
      phone: value,
      phoneErr: isValid ? "" : "10 digits phone number is required.",
      error: {
        ...prevState.error,
        phone: isValid ? "none" : "block",
      },
    }));
  };

  const setPsw = (e) => {
    setState((prevState) => ({
      ...prevState,
      psw: e.target.value,
    }));

    var password = e.target.value;
    var error = { ...state.error };

    if (password.length === 0) {
      setState((prevState) => ({
        ...prevState,
        pswErr: "Password is required.",
        error: { ...error, psw: "block" },
      }));
      return;
    } else {
      if (password.length < 6) {
        setState((prevState) => ({
          ...prevState,
          pswErr:
            "Password should have minimum 6 characters, 1 upper case,  1 lower case, 1 special character and 1 number.",
          error: { ...error, psw: "block" },
        }));
      } else {
        var matchedCase = [];
        matchedCase.push("[$@$!%*#?&]");
        matchedCase.push("[A-Z]");
        matchedCase.push("[0-9]");
        matchedCase.push("[a-z]");
        var ctr = 0;
        for (var i = 0; i < matchedCase.length; i++) {
          if (new RegExp(matchedCase[i]).test(password)) {
            ctr++;
          }
        }
        // Display it
        switch (ctr) {
          case 0:
          case 1:
          case 2:
          case 3:
            setState((prevState) => ({
              ...prevState,
              pswErr:
                "Password should have minimum 6 characters, 1 upper case,  1 lower case, 1 special character and 1 number.",
              error: { ...error, psw: "block" },
            }));
            break;
          case 4:
            error.psw = "none";
            setState((prevState) => ({
              ...prevState,
              error: { ...error },
            }));
            break;
          default:
            return;
        }
        if (state.repsw !== "") {
          var validate = state.repsw === e.target.value;
          error = { ...state.error };
          if (validate) {
            error.repsw = "none";
          } else {
            error.repsw = "block";
          }
        }
      }
    }
    setState((prevState) => ({
      ...prevState,
      error: { ...error },
    }));
  };

  const setRepsw = (e) => {
    var validate = state.psw === e.target.value;
    setState((prevState) => ({
      ...prevState,
      repsw: e.target.value,
    }));

    var error = { ...state.error };
    if (e.target.value !== "" && validate) {
      error.repsw = "none";
    } else if (e.target.value === "" && state.psw === "") {
      error.repsw = "none";
    } else {
      error.repsw = "block";
    }

    setState((prevState) => ({
      ...prevState,
      error: { ...error },
    }));
  };

  const setEin = async (e) => {
    const einValue = e.target.value.replace(/\D/g, "");

    setState((prevState) => ({
      ...prevState,
      ein: einValue,
    }));

    if (einValue !== "") {
      var error = { ...state.error };
      error.ein = "none";
      setState((prevState) => ({
        ...prevState,
        error: { ...error },
        einMsgError: "The EIN number is required",
      }));
    }

    var res = await callApi("GET", `v1/LHS/hospital/ein/${einValue}`);
    if (res.status === 500) {
      var error = { ...state.error };
      error.ein = "block";
      setState((prevState) => ({
        ...prevState,
        error: { ...error },
        einMsgError: "EIN Number already present",
      }));
    } else {
      var error = { ...state.error };
      error.ein = "none";
      setState((prevState) => ({
        ...prevState,
        error: { ...error },
        einMsgError: "The EIN number is required",
      }));
    }
  };
  const emailRepeatCheck = async (emailToCheck) => {
    if (emailToCheck) {
      const data = { email: emailToCheck };
      const res1 = await callApi(
        "POST",
        "v1/LHS/hospital/emailCheck",
        null,
        data
      );
      const res2 = await callApi("POST", "v1/LHS/staff/emailCheck", null, data);
      const res3 = await callApi("POST", "v1/LHS/admin/emailCheck", null, data);
      return (
        res1.result === "OK" && res2.result === "OK" && res3.result === "OK"
      );
    }
    return false;
  };

  const handleBack = () => {
    history.goBack();
  };

  const continueToNext = async () => {
    const { fname, lname, email, phone, role, psw, repsw, ein, showLoader } =
      state;

    // Validation for empty fields
    if (!fname || !lname || !email || !phone || !role || !psw || !repsw) {
      setState((prevState) => ({
        ...prevState,
        error: {
          fname: !fname ? "block" : "none",
          lname: !lname ? "block" : "none",
          email: !email ? "block" : "none",
          phone: !phone ? "block" : "none",
          role: !role ? "block" : "none",
          psw: !psw ? "block" : "none",
          repsw: !repsw ? "block" : "none",
          // ein: !ein ? "block" : "none",
          showLoader: false,
        },
      }));
      return;
    }

    // Continue to the next step
    setState((prevState) => ({
      ...prevState,
      showLoader: true,
    }));

    const isEmailValid = await emailRepeatCheck();

    if (isEmailValid) {
      // localStorage.setItem("first_name", state.fname);
      // localStorage.setItem("last_name", state.lname);
      // localStorage.setItem("email", state.email);
      // localStorage.setItem("phone", state.phone);
      // localStorage.setItem("role", state.role);
      // localStorage.setItem("password", state.psw);
      // localStorage.setItem("ein", state.ein);
      history.push("/hospSignUp_2");
    } else {
      setState((prevState) => ({
        ...prevState,
        emailErr: "This Email address is already in use.",
        error: { ...prevState.error, email: "block" },
        showLoader: false,
      }));
    }
  };

  const { isConfirmPasswordVisible, isPasswordVisible, showLoader } = state;

  if (showAgreement) {
    return (
      <HospSignUp_3
        handleCloseInstructions={() => setShowAgreement(false)}
        fullName={state.fullName}
        hosAddress={state.streetAddress}
        hosCity={state.city}
        hosState={state.state}
        hosZipcode={state.zipCode}
      />
    );
  }
  return (
    <>
      <div
        className="d-flex h-screen justify-center "
        style={{ height: "100vh" }}
      >
        <div className="flex gap-[100px] items-center w-full px-4 md:!px-7 justify-center  max-w-[1440px]  ">
          <div className="w-full  md:w-[50%]  hidden  lg:flex justify-end items-center   ">
            <div className="   max-w-[720px] ">
              {" "}
              <img
                alt="img"
                src={Doctor}
                className="logInLogo"
                style={{ width: "100%", height: "94vh" }}
              />
            </div>
          </div>
          <div className="max-h-[90vh] h-auto w-full md:w-[50%]  px-0   ssu_container    flex   ">
            <div className="  px-4  lg:px-5 xl:px-0  flex flex-col items-center w-full ">
              <div className="flex flex-col items-center justify-center w-full  mt-4">
                <div className="flex items-center justify-center  gap-2  md:gap-4  relative  w-full">
                  <img
                    alt="img"
                    src={back}
                    className="brandLogo absolute left-0 hidden md:block cursor-pointer
                       "
                    onClick={handleBack}
                  />
                  <img alt="img" src={logo} className="brandLogo" />
                  <img alt="img" src={logoText} className="logInLogo" />
                </div>
                <div className=" lg:hidden mt-4  flex items-center justify-center ">
                  <img
                    alt="img"
                    src={DoctorMobile}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center  flex-col justify-center gap-7">
                  <div className="logIn_txt1 font-semibold text-2xl mt-4 font-inter ">
                    Create Account
                  </div>
                </div>
                <div className="font-inter text-xl font-normal text-center mt-4 max-w-[500px]">
                  Get qualified staff on-demand for your{" "}
                  <span style={{ whiteSpace: "nowrap" }}>
                    Healthcare Institution
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2   w-full">
                <div className="ssu2_modal1_input py-1 mt-2">
                  <p className="inputLabel flex">
                    {" "}
                    Full Name <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      className="ssu2_modal3_select"
                      placeholder="Enter your full name"
                      type="text"
                      value={state.fullName}
                      name="fullName"
                      onChange={setVal}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                    />
                  </div>
                  <ErrorState
                    show={state.error.fullName}
                    name="Full Name is required."
                  />
                </div>

                <div className="ssu2_modal1_input py-1">
                  <p className="inputLabel flex">
                    Company Email Address{" "}
                    <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      className="ssu2_modal3_select"
                      placeholder="Enter company email address"
                      type="text"
                      value={state.email}
                      name="email"
                      onChange={setEmail}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                    />
                  </div>
                  <ErrorState show={state.error.email} name={state.emailErr} />
                </div>

                <div className="ssu2_modal1_input p-0">
                  <p className="inputLabel flex">
                    Phone Number <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                    <PhoneInput
                      country={"us"}
                      onlyCountries={["us"]}
                      disableDropdown={true}
                      enableAreaCodes={true}
                      countryCodeEditable={false}
                      value={state.phone}
                      onChange={setPhone}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                      containerStyle={{
                        width: "100%",
                      }}
                      buttonStyle={{
                        border: "none",
                        background: "transparent",
                        marginLeft: "10px",
                        borderRight: "1px solid #ccc",
                        marginRight: "10px",
                        paddingRight: "8px",
                        marginTop: "10px", // More space on top
                        marginBottom: "10px", // More space on bottom
                        height: "calc(100% - 20px)",
                        width: "40px", // Adjusted to match reduced height
                      }}
                      dropdownStyle={{ borderRadius: "8px" }}
                      inputClass="custom-phone-input"
                    />
                  </div>
                  <ErrorState
                    show={state.error.phone}
                    name={
                      state.phoneErr || "10 digits phone number is required."
                    }
                  />
                </div>
                <div className="ssu2_modal1_input py-1">
                  <p className="inputLabel flex ">
                    Your Role in Hiring Process{" "}
                    <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      className="ssu2_modal3_select"
                      placeholder="Your role in hiring process."
                      type="text"
                      value={state.role}
                      name="role"
                      onChange={setRole}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                    />
                  </div>
                  <ErrorState
                    show={state.error.role}
                    name="The role in hiring process is required. "
                  />
                </div>
                <div className="ssu2_modal1_input py-1">
                  <p className="inputLabel flex">
                    {" "}
                    Password <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      id="psw"
                      className="ssu3_password"
                      placeholder="Enter your password"
                      type={isPasswordVisible ? "text" : "password"}
                      value={state.psw}
                      name="psw"
                      onChange={setPsw}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                    />
                    <div
                      className="ssu3_eye"
                      onClick={togglePasswordVisibility}
                    >
                      {isPasswordVisible ? (
                        <VisibilityIcon
                          id="o_psw"
                          style={{ display: "block" }}
                        />
                      ) : (
                        <VisibilityOffIcon
                          id="c_psw"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                  </div>
                  <ErrorState
                    show={state.error.psw}
                    name="Password is required."
                  />
                </div>
                <div className="ssu2_modal1_input py-1">
                  <p className="inputLabel flex">
                    {" "}
                    Confirm Password <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      id="repsw"
                      className="ssu3_password"
                      placeholder="Enter your confirm password"
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      value={state.repsw}
                      name="repsw"
                      onChange={setRepsw}
                      onKeyUp={(e) => {
                        if (e.key === "Enter") continueToNext();
                      }}
                    />
                    <div
                      className="ssu3_eye"
                      onClick={toggleConfirmPasswordVisibility}
                    >
                      {isConfirmPasswordVisible ? (
                        <VisibilityIcon
                          id="o_psw"
                          style={{ display: "block" }}
                        />
                      ) : (
                        <VisibilityOffIcon
                          id="c_psw"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                  </div>
                  <ErrorState
                    show={state.error.repsw}
                    name="Doesn't match with the password."
                  />
                </div>
                {/* healthcare institution details  */}
                <div className="flex flex-col gap-2 mt-4">
                  <p className="font-inter text-xl font-normal text-center ">
                    Please provide your Healthcare Institution details
                  </p>
                  <div className="flex flex-col ">
                    <div className="ssu2_modal1_input py-1 mt-2">
                      <p className="inputLabel flex">
                        {" "}
                        Healthcare Institution Name{" "}
                        <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="Healthcare Institution Name"
                          type="text"
                          value={state.institutionName}
                          name="institutionName"
                          onChange={setVal}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") continueToNext();
                          }}
                        />
                      </div>
                      <ErrorState
                        show={state.error.institutionName}
                        name="Institution Name is required."
                      />
                    </div>
                    <div className="ssu2_modal1_input py-1 mt-2">
                      <p className="inputLabel flex ">
                        {" "}
                        Healthcare Institution Size
                        <p className="ml-1 text-red-700 ">*</p>{" "}
                      </p>
                      <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="e.g. 50-100 employees"
                          type="text"
                          value={state.institutionSize}
                          name="institutionSize"
                          onChange={setVal}
                          onKeyDown={(e) => {
                            // Prevent non-numeric characters
                            if (["-", "+", "e", "E"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") continueToNext();
                          }}
                        />
                      </div>
                      <ErrorState
                        show={state.error.institutionSize}
                        name="Institution Size is required."
                      />
                    </div>
                    <div className="ssu2_modal1_input py-1 mt-2">
                      <p className="inputLabel flex">
                        {" "}
                        Healthcare Institution Website{" "}
                        <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="e.g. www.healthcare.com"
                          type="text"
                          value={state.institutionWebsite}
                          name="institutionWebsite"
                          onChange={setVal}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") continueToNext();
                          }}
                        />
                      </div>
                      <ErrorState
                        show={state.error.institutionWebsite}
                        name=" Valid website address is required."
                      />
                    </div>
                  </div>
                </div>
                {/* Corporate Office Address */}
                <div className="flex flex-col gap-1 mt-3">
                  <p className="font-inter text-xl font-normal text-center ">
                    Corporate Office Address
                  </p>
                  <div className="flex flex-col ">
                    <div className="ssu2_modal1_input py-1 ">
                      <p className="inputLabel flex">
                        Zip Code <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input  ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="Enter zip code"
                          type="text"
                          value={state.zipCode}
                          name="zipCode"
                          onChange={setVal}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") continueToNext();
                          }}
                        />
                      </div>
                      <ErrorState
                        show={state.error.zipCode}
                        name="Valid zip code is required."
                      />
                    </div>

                    <div className="ssu2_modal1_input ">
                      <p className="inputLabel flex">
                        Street Address <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="Enter street address"
                          type="text"
                          value={state.streetAddress}
                          name="streetAddress"
                          onChange={setVal}
                          onKeyUp={(e) => {
                            if (e.key === "Enter") continueToNext();
                          }}
                        />
                      </div>
                      <ErrorState
                        show={state.error.streetAddress}
                        name="Street Address is required."
                      />
                    </div>

                    <div className="ssu2_modal1_input ">
                      <p className="inputLabel flex">
                        State <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="Enter city"
                          type="text"
                          value={state.state}
                          name="city"
                          readOnly
                        />
                      </div>
                      <ErrorState
                        show={state.error.state}
                        name="State is required."
                      />
                    </div>

                    <div className="ssu2_modal1_input  ">
                      <p className="inputLabel flex">
                        City <p className="ml-1 text-red-700 ">*</p>
                      </p>
                      <div className="ssu2_modal1_input  ssu2_modal3_selectBox">
                        <input
                          className="ssu2_modal3_select"
                          placeholder="Enter city"
                          type="text"
                          value={state.city}
                          name="city"
                          readOnly
                        />
                      </div>
                      <ErrorState
                        show={state.error.city}
                        name="City is required."
                      />
                    </div>
                    {/* terms and condition  */}
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center gap-1 w-full text-xs sm:text-sm md:text-base whitespace-nowrap truncate">
                        <img
                          src={state.isTermsAccepted ? checkBox : uncheck}
                          onClick={handleTermsCheckboxToggle}
                          className="cursor-pointer flex-shrink-0 w-4 h-4"
                          alt="checkbox"
                        />
                        <span className="font-inter font-normal whitespace-nowrap truncate">
                          I provide my consent to
                        </span>
                        <span
                          onClick={() =>
                            window.open(
                              "https://linkhealthstaff.com/terms-and-conditions/",
                              "_blank"
                            )
                          }
                          className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap ml-1"
                        >
                          Terms of Service
                        </span>
                        <span className="whitespace-nowrap mx-1">&</span>
                        <span
                          onClick={() =>
                            window.open(
                              "https://linkhealthstaff.com/privacy%20policy/",
                              "_blank"
                            )
                          }
                          className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap"
                        >
                          Privacy Policy
                        </span>
                      </div>

                      <div className="flex items-center gap-1 w-full text-xs sm:text-sm md:text-base whitespace-nowrap truncate">
                        <img
                          src={
                            state.isMedicalAgreementAccepted
                              ? checkBox
                              : uncheck
                          }
                          onClick={handleMedicalAgreementCheckboxToggle}
                          className="cursor-pointer flex-shrink-0 w-4 h-4"
                          alt="checkbox"
                        />
                        <span className="font-inter font-normal whitespace-nowrap truncate">
                          I provide my consent to
                        </span>
                        <span
                          className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap ml-1"
                          onClick={() => setShowAgreement(true)}
                        >
                          Hospital Staff Agreement
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <div
                    className={`logIn_button d-flex align-items-center justify-content-center p-0 h-14 ${
                      !isFormValid() ? "disabled-signup-btn !font-inter" : ""
                    }`}
                    onClick={isFormValid() ? finishSignUp : null}
                  >
                    {showLoader ? (
                      <Loader />
                    ) : (
                      <p className="text-base font-semibold">Sign Up</p>
                    )}
                  </div>
                  <p className="font-normal text-lg font-inter text-center mt-4">
                    Already have an account?{" "}
                    <Link className="text-[#73C7A9]" to="/login">
                      Log in
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HospSignUp;
